import React from 'react';
import PropTypes from 'prop-types';

export const PaidStatus = ({ width, height, ...props }) => (
  <svg
    data-icon='paid-status'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='m17.275 20.25 3.475-3.45-1.05-1.05-2.425 2.375-.975-.975-1.05 1.075 2.025 2.025ZM6 9h12V7H6v2Zm12 14c-1.383 0-2.563-.488-3.537-1.462C13.488 20.562 13 19.383 13 18s.488-2.563 1.463-3.537C15.438 13.488 16.617 13 18 13s2.563.488 3.538 1.463C22.512 15.438 23 16.617 23 18s-.488 2.563-1.462 3.538C20.562 22.512 19.383 23 18 23ZM3 22V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 3h14c.55 0 1.02.196 1.413.587C20.803 3.98 21 4.45 21 5v6.675a6.922 6.922 0 0 0-2-.6V5H5v14.05h6.075c.083.517.213 1.008.388 1.475.175.467.404.908.687 1.325L12 22l-1.5-1.5L9 22l-1.5-1.5L6 22l-1.5-1.5L3 22Zm3-5h5.075a7.013 7.013 0 0 1 .6-2H6v2Zm0-4h7.1a7.156 7.156 0 0 1 2.213-1.463A6.79 6.79 0 0 1 18 11H6v2Z'
    />
  </svg>
);

PaidStatus.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

PaidStatus.defaultProps = {
  width: 24,
  height: 24,
};
